import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router';
import { history } from 'state/store';
import { StyledLink } from './Login.styles';
import { isPostAuthPageAccessed } from 'domain/views/LoginForm/Login.helpers';

const LoginLink = () => {
  const [portalRoot, setPortalRoot] = useState<HTMLElement | null>(null);
  const location = useLocation();

  useEffect(() => {
    const link = document.getElementById('buyers_login_link');
    const root = link?.parentElement;
    if (link && root) {
      root.removeChild(link);
      setPortalRoot(root);

      if (isPostAuthPageAccessed(location.pathname)) {
        history.push({ hash: 'buyerLogin' });
      }
    }
  }, []);

  const onLinkClick = (
    e: React.MouseEvent<HTMLAnchorElement> | React.TouchEvent<HTMLAnchorElement>,
  ) => {
    e.preventDefault();
    if (e.bubbles) {
      e.stopPropagation();
    }
    history.push({
      ...location,
      hash: 'buyerLogin',
    });

    const menu = document.querySelector('ul.white.fw-normal.menu_with_sub.menu_show');

    if (menu) {
      menu.classList.remove('menu_show');
    }
  };

  if (!portalRoot) {
    return null;
  }

  return createPortal(
    <StyledLink
      className="login"
      to={'#buyerLogin'}
      onClickCapture={onLinkClick}
    >
      Log in
    </StyledLink>,
    portalRoot,
  );
};

export default LoginLink;
